module.exports = __webpack_public_path__ + "img/fr-diag-placeholder.52afb5fb.png";